module.exports = __webpack_public_path__ + "img/customer.a47ced34.svg";